export const SPORT_OPTIONS = [
  { value: 'chess', label: 'Chess' },
  { value: 'football', label: 'Football' },
  { value: 'cricket', label: 'Cricket' },
  { value: 'tennis', label: 'Tennis' },
  { value: 'basketball', label: 'Basketball' },
  { value: 'swimming', label: 'Swimming' },
  { value: 'badminton', label: 'Badminton' },
  { value: 'athletics', label: 'Athletics' },
];

// Full class names so Tailwind's content scan keeps them.
const SPORT_GRADIENTS: Record<string, string> = {
  chess: 'from-emerald-600 to-teal-900',
  football: 'from-blue-600 to-indigo-900',
  cricket: 'from-amber-500 to-orange-800',
  tennis: 'from-lime-500 to-green-800',
  basketball: 'from-violet-600 to-purple-900',
  swimming: 'from-cyan-500 to-blue-800',
  badminton: 'from-rose-500 to-pink-800',
  athletics: 'from-slate-500 to-slate-800',
};

export const sportGradient = (sport?: string) =>
  SPORT_GRADIENTS[(sport || '').toLowerCase()] || 'from-indigo-600 to-slate-900';

const STATUS_STYLES: Record<string, string> = {
  upcoming: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  ongoing: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  completed: 'bg-slate-100 text-slate-600 ring-slate-500/20',
  cancelled: 'bg-red-50 text-red-700 ring-red-600/20',
  postponed: 'bg-amber-50 text-amber-800 ring-amber-600/20',
};

export const statusStyle = (status?: string) =>
  STATUS_STYLES[status || ''] || 'bg-slate-100 text-slate-600 ring-slate-500/20';

export const capitalize = (value?: string) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : '';

export const formatLabel = (value?: string) =>
  (value || '')
    .split('-')
    .map(capitalize)
    .join(' ');

export const formatFee = (fee?: number) => (!fee ? 'Free' : `₹${fee.toLocaleString('en-IN')}`);

export const daysUntil = (dateString?: string): number | null => {
  if (!dateString) return null;
  const target = new Date(dateString);
  if (isNaN(target.getTime())) return null;
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  return Math.round((target.getTime() - startOfToday.getTime()) / 86400000);
};

export const countdownLabel = (dateString?: string): string | null => {
  const days = daysUntil(dateString);
  if (days === null) return null;
  if (days < 0) return null;
  if (days === 0) return 'Today';
  if (days === 1) return 'Tomorrow';
  return `In ${days} days`;
};
